import type { TableCommandFactory } from 'components/Table/model/TableModel';
import { saveTableSettings } from 'components/Table/model/commands/saveTableSettings';
import { selectRenderedColumnWidths } from 'components/Table/model/selectors/selectRenderedColumnWidths';
import { TABLE_COLUMN_MIN_WIDTH } from 'components/Table/tableSettings';
import { getFilteredColumnMinWidth } from './helpers/getFilteredColumnMinWidth';

interface ResizeTableColumnCommand {
  columnKey: string;
  delta: number;
}

export const resizeTableColumn: TableCommandFactory<ResizeTableColumnCommand> =
  (cmdContext, dispatch) => async (command) => {
    if (command.delta === 0) {
      return;
    }

    const filter =
      cmdContext.getState().simpleFilterFields?.[command.columnKey];
    const appliedFilter = !!filter?.value;

    // Use the rendered width so first resize starts from the actual on-screen value,
    // including equal-width columns that do not yet have a stored width.
    const currentWidth =
      selectRenderedColumnWidths(cmdContext.getState())[command.columnKey] ??
      TABLE_COLUMN_MIN_WIDTH;

    const minWidth = appliedFilter
      ? getFilteredColumnMinWidth(filter?.filter)
      : TABLE_COLUMN_MIN_WIDTH;

    const newWidth = Math.max(minWidth, currentWidth + command.delta);

    cmdContext.updateState((draft) => {
      draft.settings.autoSizedColumns = false;
      draft.settings.columnWidth = draft.settings.columnWidth ?? {};
      draft.settings.columnWidth[command.columnKey] = newWidth;
    });
    await dispatch(saveTableSettings);
  };
